export const colorTokens = {
  white:     '#ffffff',
  blue100:   '#cce0f2',
  blue200:   '#0d6efd',
  blue350:   '#2677b6',
  blue400:   '#0079C9',
  blue500:   '#0066B3',
  blue550:   '#0061ae',
  blue600:   '#005CA9',
  blue650:   '#00599C',
  blue700:   '#0254A4',
  blue900:   '#00477d',
  blue950:   '#093470',
  teal400:   '#4DB4AB',
  teal450:   '#4CB2AC',
  purple50:  '#faf6ff',
  purple100: '#ece2fc',
  purple300: '#996fdc',
  purple400: '#a89be7',
  purple500: '#7B2D8B',
  purple600: '#5f2ab2',
  purple650: '#3E00AD',
  purple700: '#4a1f8f',
  grey50:    '#f7f8f9',
  grey100:   '#f4f2f2',
  grey150:   '#e9ecef',
  grey200:   '#c4c5c6',
  grey400:   '#98A6AD',
  grey300:   '#838383',
  grey490:   '#62738a',
  grey500:   '#5c5c5c',
  grey540:   '#4b5a6f',
  grey550:   '#495057',
  grey580:   '#47566b',
  grey600:   '#464646',
  grey650:   '#3d4d63',
  grey700:   '#313131',
  grey800:   '#2E3139',
  black:     '#000000',
  red:       '#DD1D1D',
  red100:    '#f8d7da',
  red700:    '#B10A2A',
  red800:    '#AB0222',
  red900:    '#721c24',
  green100:  '#DCFFE0',
  green500:  '#00EF1C',
  green600:  '#00BD80',
  green700:  '#219D1D',
  yellow100: '#FFF1C7',
  yellow500: '#FFBF00',
  yellow600: '#FAB901',
  yellow700: '#AF8300',
  orange50:  '#ffe7d1',
  orange100: '#FFDBD1',
  orange200: '#FF7A00',
  orange300: '#F7941E',
  orange500: '#FF4F1C',
  orange600: '#c22e05',
  orange700: '#F08800',
  orange800: '#a95100',
  indigoShadow: 'rgba(68, 102, 242, 0.13)',
  indigoShadowStrong: 'rgba(68, 102, 242, 0.3)',
  shadowBlack: 'rgba(0, 0, 0, 0.13)',
  shadowSmooth: '#2E313922',
  shadowSoft: 'rgba(0, 0, 0, 0.075)',
  iconMuted: 'rgba(0, 0, 0, 0.55)',
  borderMuted: 'rgba(0, 0, 0, 0.1)',
  teal700:   '#1F716C',
  green400:  '#22A640',
  slate50:   '#f8f9fc',
  slate100:  '#eef0f6',
  slate150:  '#e8eaf0',
  slate200:  '#dde3ef',
  slate300:  '#c8cdd8',
  slate400:  '#b0b8cc',
  slate500:  '#6b7a99',
  slate900:  '#1a2b4a',
  sky100:    '#e8f0fb',
  sky400:    '#1a6fc4',
  spaceColor1:  '#1ebb1b',
  spaceColor2:  '#00b2e2',
  spaceColor6:  '#6d4c41',
  spaceColor7:  '#c2185b',
  spaceColor8:  '#5f6368',
  spaceColor10: '#455a64',
  overlayTint:       'rgba(0, 0, 0, 0.4)',
  overlayTintStrong: 'rgba(0, 0, 0, 0.78)',
  overlayTintSoft:   'rgba(255, 255, 255, 0.88)',
  shadowCardOuter:   'rgba(0, 0, 0, 0.08)',
  shadowCardInner:   'rgba(0, 0, 0, 0.06)',
  shadowElevatedSm:  'rgba(0, 0, 0, 0.1)',
  shadowElevatedMd:  'rgba(0, 0, 0, 0.15)',
  shadowElevatedLg:  'rgba(0, 0, 0, 0.2)',
  shadowPopover:     'rgba(26, 43, 74, 0.12)',
} as const
